export default function(gsap, SplitText) {
    if (!gsap || !SplitText) return;

    const revealString = document.querySelector('[data-string-reveal]');
    if (!revealString) return;

    document.fonts.ready.then(() => {
        revealString.style.setProperty('--data-string-reveal-opacity', 1);

        const titleWrapper = revealString.parentNode;
        titleWrapper.style.height = titleWrapper.offsetHeight + 'px';

        let split = {};
        const stringRevealValue = revealString.dataset?.stringReveal;

        if (stringRevealValue === 'noSplit') {
            split.chars = Array.from(revealString.children);
        } else {
            split = new SplitText(revealString, {
                type: "chars,words",
                charsClass: "char",
                wordsClass: 'string-reveal-group',
            });
        }

        const tween = gsap.from(split.chars, {
            y: "100%",
            duration: 1.2,
            ease: "power2.out",
            delay: 0.6,
            stagger: {
                each: 0.05,
                from: "start"
            },
        });

        gsap.delayedCall(tween.totalDuration() - 0.4, () => {
            revealString?.querySelectorAll(".string-reveal-group").forEach(el => {
                gsap.to(el, {
                    clipPath: "inset(-20px 0px)",
                    duration: 0.4,
                    ease: "power2.out"
                });
            });
        });
    });
}
